module.exports = __webpack_public_path__ + "static/media/2019-08-22-01.71e3e7fb.jpg";